import React, { createContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from './redux/store';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import persistor from './redux/store';
import './css/style.css';
import './css/satoshi.css';
import './css/poppins.css';
import { useAppBridge } from '@shopify/app-bridge-react';
import createApp from '@shopify/app-bridge/client/Client.js';
import { NavMenu } from '@shopify/app-bridge-react';

// Create contexts
const RoleContext = createContext();
export const sidebarContext = createContext();
export const sidebarContextDispatch =createContext();
export const VideoCreationContext = createContext();
export const VideoCreationDispatchContext = createContext();
export default RoleContext;
export const ShopifyAppContext = createContext();

(async () => {
    const container = document.getElementById('root');
    const root = createRoot(container);

    // Determine the role based on the URL
    // Dynamically import the router module
    let role;
    let routerModule;
    if (location.pathname.startsWith("/admin")) {
        role = "admin"
        routerModule = await import('./router/AdminRouter.js')
    } else if (location.pathname.startsWith("/staff")) {
        role = "staff";
        routerModule = await import('./router/StaffRouter.js');
    } else if (location.pathname.startsWith("/app")) {
        role = "app";
        routerModule = await import('./router/AppRouter.js');
    } else if (location.pathname.startsWith("/broadcast")) {
        role = "broadcast"
        routerModule = await import('./router/BroadcastRouter.js');
    } else if (location.pathname.startsWith("/")) {
        role = "root"
        routerModule = await import('./router/LandingPageRouter2.js');
    }
    const router = routerModule.default;

    const AppBridgeInitializer = ({ setAppConfig }) => {
        const appBridge = useAppBridge();
        useEffect(() => {
            if (appBridge?.config) {
                console.log("settingconfig");
                setAppConfig(createApp({
                    apiKey: appBridge.config.apiKey,
                    host: appBridge.config.host,
                }));
            }
        }, [appBridge, setAppConfig]);
        return null; 
    };

    const AppWrapper = () => {
        const [appConfig, setAppConfig] = useState('');
        const [sidebarOpen, setSidebarOpen] = useState(false);
        const [videoCreationData, setVideoCreationData] = useState(null);

        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <RoleContext.Provider value={role}>
                        <sidebarContext.Provider value={sidebarOpen}>
                        <sidebarContextDispatch.Provider value={setSidebarOpen}>
                        <VideoCreationContext.Provider value={videoCreationData}>
                        <VideoCreationDispatchContext.Provider value={setVideoCreationData}>
                        <ShopifyAppContext.Provider value={appConfig}>
                            {role === 'app' && <AppBridgeInitializer setAppConfig={setAppConfig} />}
                            {/* {role === 'app' && <ShopifyNavMenu />} */}
                            <RouterProvider router={router} />
                        </ShopifyAppContext.Provider>
                        </VideoCreationDispatchContext.Provider>
                        </VideoCreationContext.Provider>
                        </sidebarContextDispatch.Provider>
                        </sidebarContext.Provider>
                    </RoleContext.Provider>
                </PersistGate>
            </Provider>
        );
    };

    // Render the application
    root.render(
        <>
            <AppWrapper />
            <ToastContainer />
            {/* <GoogleTranslate/> */}
        </>
    );
})();

export function ShopifyNavMenu() {
    const { plan: userPlan, isDummyShop } = useSelector((state) => state.user_info);
    const isFreePlan = userPlan?.name === 'free';

    return (
        <NavMenu>
            <a href="/app" rel="home">
                Dashboard
            </a>
            <a href="/app/product">Product</a>
            <a href="/app/shoppable-videos">Shoppable Videos</a>
            <a href="/app/live-stream"> Live Stream</a>
            <a href="/app/video-collection"> Video Collection</a>
            { !isFreePlan && isDummyShop &&
                <a href="/app/featured-apps"> Featured Apps</a>
            }
            <a href="/app/staff"> Staff</a>
            <a href="/app/plans/main-plan"> Main Plan</a>
            <a href="/app/plans/digital-plan"> Digital Plan</a>
            <a href="/app/settings/store-setting"> Store Setting</a>
            <a href="/app/settings/profile"> Profile Setting</a>
            <a href="/app/settings/frontend-configuration"> Frontend Configuration</a>
            <a href="/app/email-configuration"> Email Configuration</a>
        </NavMenu>
    );
}